import { Map } from 'immutable';

import {
  RECEIVE_LIMITED_USERS,
  RECEIVE_USERS,
  REQUEST_ALL_USERS,
  REQUEST_USER,
} from '@sophocles/entities/User/userActions';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_USERS:
      return state.mergeDeep(action.users);
    case RECEIVE_LIMITED_USERS:
      return state.mergeDeep(action.users);
    case REQUEST_ALL_USERS:
    case REQUEST_USER:
    default:
      return state;
  }
}

export function userReducer(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_USERS:
    case RECEIVE_LIMITED_USERS:
    case REQUEST_ALL_USERS:
    case REQUEST_USER:
      return getState(state, action);
    default:
      return state;
  }
}
